import { GameSummaryProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSummaryProperties";
/**
 * SummaryPortraitProperties.ts
 */
export class SummaryPortraitProperties extends GameSummaryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(512, 876);
    }
}
//# sourceMappingURL=SummaryPortraitProperties.js.map